import { LogSync } from "./sync/log-sync.js";
export function createConversationLogSync(service) {
    return new LogSync({
        apply: async (payload) => {
            await service.applyDelta(payload);
        },
    });
}
//# sourceMappingURL=conversation-sync.js.map